import React from 'react';
import SkeletonCard from '../../../../components/Skeleton/Card';

export const LoadingEmployeeFeedbacks: React.FC = () => (
  <SkeletonCard height={180} />
);
